const m = {};
m.metric = {
    gram: 'g',
    liters: 'l',
    ml: 'ml',
    kilogram: 'kg',
    milligram: 'mg',
}
m.american = {
    ounces: 'oz',
    pounds: 'lbs',
    cups: 'cups',
    teaspoon: 'tsps',
    tablespoon: 'tbps',
    gallons: 'gal',
    serving_size: 'serving_size'
}

export default m;



// WEBPACK FOOTER //
// ./src/Constants/measurements.js